import ContextPageView from "../components/entityViews/context/ContextPageView";

const ContextPage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="context-page">
      <div className="flex-1 min-h-0">
        <ContextPageView />
      </div>
    </div>
  );
};

export default ContextPage;
